module.exports = __webpack_public_path__ + "img/video-file-1281615872381304.496a4868.png";